import React, { Fragment } from "react";
import {
    Header, Segment, Button, Icon, Search, Checkbox, Modal, Form, Radio, Accordion, Menu, Input
} from 'semantic-ui-react';
import NoResultFound from "../sharedComponent/noResultFound"
import Loader from "../sharedComponent/loader/loader";
import TimeKeeper from 'react-timekeeper';
import { Constants } from '../../config/appConstants';
import ConfirmationPopup from "../timeCard/TMVoucher/TMVoucherComponents/ConfirmationPopup";
import { CheckEnterHours } from "../timeCard/Attestation/AttestationUtils";

const EmployeeComponent = props => {
    const onSelectedHours = props.employee.onSelectedHours;
    const isZeroHour = Number(onSelectedHours) === 0;
    const isHoursGreaterThanZero = Number(onSelectedHours) > 0;
    const isFourPointFiveHours = CheckEnterHours(Number(onSelectedHours));

    const timeCardDataFromTCPage = props?.employee?.timeCardDataFromTCPage;
    const totalStHours = timeCardDataFromTCPage?.totalStHours;
    const totalOtHours = timeCardDataFromTCPage?.totalOtHours;
    const totalDtHours = timeCardDataFromTCPage?.totalDtHours;
    const totalHoursIsZero = (totalStHours === 0 && totalOtHours === 0 && totalDtHours === 0);
    const lunchStartInputDisable = ((isZeroHour || (props.employee.savedLunchStartTime === Constants.NOT_APPLICABLE && !isFourPointFiveHours)) || totalHoursIsZero);
    const lunchEndInputDisable = ((isZeroHour || (props.employee.savedLunchEndTime === Constants.NOT_APPLICABLE && !isFourPointFiveHours)) || totalHoursIsZero);

    const lunchStartCheckBoxValue = (props.employee.savedLunchStartTime === Constants.NOT_APPLICABLE || isZeroHour) && !isFourPointFiveHours;
    const lunchEndCheckBoxValue = (props.employee.savedLunchEndTime === Constants.NOT_APPLICABLE || isZeroHour) && !isFourPointFiveHours;

    const punches_text = {
        'StarTime': [Constants.START_TIME_TEXT, Constants.START_HOUR, Constants.START_MINUTES, Constants.START_TIME],
        'EndTime': [Constants.END_TIME_TEXT, Constants.END_HOUR, Constants.END_MINUTES, Constants.END_TIME],
        'LunchStart': [Constants.LUNCH_START_TIME_TEXT, Constants.LUNCH_START_HOUR, Constants.LUNCH_START_MINUTES, Constants.LUNCH_START_TIME],
        'LunchEnd': [Constants.LUNCH_END_TIME_TEXT, Constants.LUNCH_END_HOUR, Constants.LUNCH_END_MINUTES, Constants.LUNCH_END_TIME]
    };

    const punches_text_keys = Object.keys(punches_text);

    const TimeInput = (hourRef, minuteRef, hourValue, minuteValue, hourName, minuteName, inputDisable) => (
        <Fragment>
            <Input className="punchesInput" disabled={inputDisable} ref={hourRef} minLength="1" maxLength="3"
                onChange={(e) => props.onChangePunches(e.target.value, hourName)}
                value={hourValue === Constants.NOT_APPLICABLE ? '' : hourValue}
            />
            <span>:</span>
            <Input className="punchesInput" disabled={inputDisable} ref={minuteRef} minLength="1" maxLength="3"
                onChange={(e) => props.onChangePunches(e.target.value, minuteName)}
                value={minuteValue === Constants.NOT_APPLICABLE ? '' : minuteValue}
            />
        </Fragment>
    )

    const groupTimeInput = ({ inputname, hourValue, minuteValue, checkBoxDisable, inputDisable, checkBoxValue, hourRef = null, minuteRef = null }) => {
        const [inputTitle, hourName, minuteName, checkBoxName] = punches_text[inputname];
        const isNASelected = checkBoxValue && hourValue === "" && minuteValue === "";
        return (
            <div className="d-flex gap-5">
                <div>
                    <Header as='h4' textAlign='center'>{inputTitle}</Header>
                    <Form.Group className="align-items startWindowsTime">
                        {TimeInput(hourRef, minuteRef, hourValue, minuteValue, hourName, minuteName, inputDisable)}
                    </Form.Group>
                </div>
                <div className="d-flex flexDirectionColumn checkbox-gap">
                    <Header as='h4' textAlign='center'>{Constants.NOT_APPLICABLE}</Header>
                    <Checkbox className="selectedTable" disabled={checkBoxDisable}
                        checked={isNASelected}
                        onChange={() => (!isZeroHour || totalHoursIsZero) && props.onClickNA(checkBoxName, isNASelected)}
                    />
                </div>
            </div>
        )
    }

    return (
        <Segment.Group>
            {/*SaveConfimation popup */}
            <Modal
                open={props.employee.isConfirmationModelVisible}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">{Constants.CONFIRMATION}</Modal.Header>
                <Modal.Content >
                    {Constants.CONFIRMATION_POPUP_MESSAGE}
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onConfirmationCancel}>
                        No
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onConfirmationYes}>
                        Yes
                    </Button>
                </Modal.Actions>
            </Modal>
            {props.employee.selectedTab !== 'starttimeandtunchtime' &&
                <Segment className="stickyHeader">
                    <Header as="h3" size='medium' textAlign='center'> Create Employee Timecards</Header>
                    <Header as="h2" size='tiny' className='layoutStyle d-flex align-items justify-content-between overflowScroll'>
                        <Button onClick={() => props.onTabSelect("project")} active={props.employee.previousTab === "" && props.employee.selectedTab === 'project'} secondary className="borderRadius borderColor whiteSpace" fluid size='small'>
                            <Icon name={props.employee.selectedTab === 'project' ? 'check circle outline' : 'clipboard outline'} /> Select Project {props.employee.savedProject ? <span>- {props.employee.savedProject.projectNumber}</span> : null} </Button>
                        <Button onClick={() => props.onTabSelect("taskcodes", true)} active={props.employee.previousTab === "" && props.employee.selectedTab === 'taskcodes'} secondary className="borderRadius borderColor whiteSpace" fluid size='small'>
                            <Icon name={props.employee.selectedTab === 'taskcodes' ? 'check circle outline' : 'file outline'} /> Select Task Code {props.employee.savedTask ? `- ${props.employee.savedTask.taskNumber}` : ""}  </Button>
                        <Button onClick={props.onClickShiftModel} active={props.employee.previousTab === 'shift'} secondary className="borderRadius borderColor whiteSpace" fluid size='small'>
                            <Icon name={props.employee.previousTab === 'shift' ? 'check circle outline' : 'sync alternate'} /> Select Shift {props.employee.savedShift ? `- ${props.employee.savedShift}` : ""} </Button>
                        <Button onClick={props.onClickHoursTypeModel} active={props.employee.previousTab === 'hoursType'} secondary className="borderRadius borderColor whiteSpace" fluid size='small'>
                            <Icon name={props.employee.previousTab === 'hoursType' ? 'check circle outline' : 'clock outline'} /> Select Pay Code {props.employee.savedHoursType ? `- ${props.employee.savedHoursType}` : ""} </Button>
                        <Button onClick={props.onClickHoursModel} active={props.employee.previousTab === 'hours'} secondary className="borderRadius borderColor whiteSpace" fluid size='small'>
                            <Icon name={props.employee.previousTab === 'hours' ? 'check circle outline' : 'clock outline'} /> Enter Hours {props.employee.savedHoursValue ? `- ${props.employee.savedHoursValue}` : ""} </Button>
                        <Button onClick={() => props.onTabSelect("starttimeandtunchtime")} active={props.employee.previousTab === "" && props.employee.selectedTab === 'starttimeandtunchtime'} secondary className="borderRadius borderColor whiteSpace" fluid size='small'>
                            <Icon name={props.employee.selectedTab === 'starttimeandtunchtime' ? 'check circle outline' : 'clock outline'} /> Punches {props.employee.savedStartTime ? `- ${props.employee.savedStartTime},` : ""} {props.employee.savedLunchStartTime ? `${props.employee.savedLunchStartTime},` : ""} {props.employee.savedLunchEndTime ? `${props.employee.savedLunchEndTime},` : ""} {props.employee.savedEndTime ? `${props.employee.savedEndTime}` : ""} </Button>
                    </Header>
                </Segment>
            }
            {/* If You need to show Team List and Employee List Use this below Code */}

            {/* If You need to show Full Employee List Use this below Code */}
            {!props.employee.selectedTab &&
                <Segment className="pb-5 root">
                    {props.employee.empGrpList && props.employee.empGrpList.length > 0 &&
                        <div className="overflowScroll accordionMenuHeight">
                            <Accordion as={Menu} className="text m-0" vertical fluid exclusive={false}>
                                {props.employee.empGrpList && props.employee.empGrpList.map(empGrp => {
                                    let isEmpGroupClicked = props.employee.activeIndexForEmpGroup.some(empGroupId => empGroupId === empGrp.groupID);
                                    return (
                                        <Menu.Item className="no-padding m-0">
                                            {/* <div className="accordionTitle"> */}
                                            <Checkbox style={{ position: 'absolute', top: '3px' }} className="selectedRow no-padding selectedGroupTask" value={empGrp.groupID} onChange={(e, data) => props.onClickSelectAllCheckboxForEmpGroup(data, empGrp)} checked={empGrp?.groupData?.length > 0 && empGrp.groupData.every(a => props?.employee?.selectedEmployeeList?.includes(Number(a.employeeID)))} />
                                            <Accordion.Title className="createTeam" active={isEmpGroupClicked}
                                                index={empGrp.groupID}
                                                onClick={props.handleClickForEmpGrp}
                                            >
                                                <div className="ml-3">
                                                    <span className="w-100 ml-2" style={{ lineHeight: '1.4em' }}>{empGrp.groupName}</span>
                                                    <div onClick={() => props.goToEmpGroup(empGrp.groupID)}>
                                                        <span className="iconify editIconEmp" data-icon="bxs:edit" data-inline="false" ></span>
                                                    </div>
                                                    <Icon name='dropdown' className="dropdownIconAccordion" />
                                                </div>
                                            </Accordion.Title>
                                            {/* </div> */}
                                            <Accordion.Content className='no-padding' active={isEmpGroupClicked}>
                                                {empGrp.groupData && empGrp.groupData.length > 0 && empGrp.groupData.map(employee => (
                                                    <Checkbox className="selectedRow empGroupSelected w-100" value={employee.employeeID} label={`${employee.employeeName} (${employee.employeeNumber})`}
                                                        onChange={props.onEmployeeSelect}
                                                        checked={props.employee.selectedEmployeeList.includes(Number(employee.employeeID))}
                                                    />
                                                ))}
                                            </Accordion.Content>
                                        </Menu.Item>
                                    )
                                })}
                            </Accordion>
                        </div>
                    }
                    {(props.employee.employeeSearchText !== '' || props.employee.allEmployeeList.length > 0) &&
                        <Search className='padding' onSearchChange={props.onEmployeeSearch} value={props.employee.employeeSearchText} placeholder="Search Employee's" />
                    }

                    <div className="mainContentRoot">

                        {props.employee.allEmployeeList && props.employee.allEmployeeList.filter(e => props.employee.selectedEmployeeList.includes(e.id)).map((employee) => (
                            <Checkbox className="selectedRow empGroupSelected w-100" value={employee.id} label={`${employee.fullName} (${employee.employeeNumber})`}
                                onChange={props.onEmployeeSelect}
                                checked={props.employee.selectedEmployeeList.includes(employee.id)}
                            />
                        ))}
                        {props.employee.allEmployeeList && props.employee.allEmployeeList.filter(e => !props.employee.selectedEmployeeList.includes(e.id)).map((employee) => (
                            <Checkbox className="selectedRow empGroupSelected w-100" value={employee.id} label={`${employee.fullName} (${employee.employeeNumber})`}
                                onChange={props.onEmployeeSelect}
                                checked={props.employee.selectedEmployeeList.includes(employee.id)}
                            />
                        ))}
                        {(props.employee.allEmployeeList.length === 0) &&
                            <NoResultFound displayMessage={"No Employee Found"} />
                        }
                        {props.employee.isShowLoader &&
                            <Loader />
                        }
                    </div>
                </Segment>
            }

            {/* Select Project Page */}
            {props.employee.selectedTab === "project" &&
                <Segment className=" pb-5 root">
                    {(props.employee.projectSearchText !== '' || props.employee.allProjectList.length > 0) &&
                        <Search className='padding' onSearchChange={props.onProjectSearch} value={props.employee.projectSearchText} placeholder="Search Projects" />
                    }
                    {props.employee.allProjectList && props.employee.allProjectList.filter(t => t.projectNumber === props.employee.selectedProject.projectNumber).map((project) => (
                        <Radio className="selectedRow w-100"
                            label={`${project.projectNumber} - ${project.projectName}`}
                            name='radioGroup'
                            value={project}
                            checked={props.employee.selectedProject && props.employee.selectedProject.projectNumber === project.projectNumber}
                        />
                    ))}
                    <div className="mainContentRoot">

                        {props.employee.allProjectList && props.employee.allProjectList.filter(t => t.projectNumber !== props.employee.selectedProject.projectNumber).map((project) => (
                            <Radio className="selectedRow w-100"
                                label={`${project.projectNumber} - ${project.projectName}`}
                                name='radioGroup'
                                value={project}
                                checked={props.employee.selectedProject && props.employee.selectedProject.projectNumber === project.projectNumber}
                                onChange={props.onProjectSelect}
                            />
                        ))}
                        {(props.employee.allProjectList.length === 0) &&
                            <NoResultFound displayMessage={"No Projects Found"} />
                        }
                        {props.employee.isShowLoader &&
                            <Loader />
                        }
                    </div>
                </Segment>
            }

            {/* Select Task Code Page */}
            {props.employee.selectedTab === "taskcodes" &&
                <Segment className="pb-5 root">
                    {props.employee.taskGrpList && props.employee.taskGrpList.length > 0 &&
                        <div className="overflowScroll accordionMenuHeight">
                            <Accordion as={Menu} className="text m-0" vertical fluid>
                                {props.employee.taskGrpList && props.employee.taskGrpList.map(taskGrp => {
                                    let isTaskGroupClicked = props.employee.activeIndexForTaskGroup.some(taskGroupId => taskGroupId === taskGrp.groupID);
                                    return (
                                        <Menu.Item className="m-0 no-padding">
                                            <Accordion.Title className="createTeam" style={{ marginBottom: '0.15em' }}
                                                active={isTaskGroupClicked}
                                                index={taskGrp.groupID}
                                                onClick={props.handleClickForTaskGrp}
                                            >
                                                <div>
                                                    <span className="w-100" style={{ lineHeight: '1.4em' }} >{taskGrp.groupName}</span>
                                                    <div onClick={() => props.goToTaskCodeGroup(taskGrp.groupID)}>
                                                        <span className="iconify editIconEmp" data-icon="bxs:edit" data-inline="false" ></span>
                                                    </div>
                                                    <Icon name='dropdown' className="dropdownIconAccordion" />
                                                </div>
                                            </Accordion.Title>
                                            <Accordion.Content className='no-padding' active={isTaskGroupClicked}>
                                                {taskGrp.groupData && taskGrp.groupData.length > 0 && taskGrp.groupData.map(task => (
                                                    <Radio className="selectedRow w-100 taskcodeSelected"
                                                        label={`${task.taskNumber} - ${task.taskName}`}
                                                        name='radioGroups'
                                                        value={task}
                                                        onChange={() => { props.onTaskCodeSelect(task, true) }}
                                                        checked={props.employee.selectedTask && props.employee.selectedTask.taskNumber === task.taskNumber && props.employee.selectedTask.taskName === task.taskName}
                                                        disabled={!props.employee.savedProject.projectNumber || props.employee.tasksNotInSelectedProject && props.employee.tasksNotInSelectedProject.some(a => a.groupID === task.groupID && a.taskNumber === task.taskNumber && a.taskName === task.taskName)}
                                                    />
                                                ))}
                                            </Accordion.Content>
                                        </Menu.Item>
                                    )
                                })}
                            </Accordion>
                        </div>
                    }
                    {(props.employee.taskSearchText !== '' || props.employee.allTaskList.length > 0) &&
                        <Search className='padding' onSearchChange={props.onTaskSearch} value={props.employee.taskSearchText} placeholder="Search Task Codes" />
                    }
                    {props.employee.selectedTask && props.employee.allTaskList && props.employee.allTaskList.filter(t => t.taskNumber === props.employee.selectedTask.taskNumber && t.taskName === props.employee.selectedTask.taskName).map((task) => (
                        <Radio className="selectedRow w-100 taskcodeSelected"
                            label={`${task.taskNumber} - ${task.taskName}`}
                            name='radioGroup'
                            value={task}
                            checked={props.employee.selectedTask && props.employee.selectedTask.taskNumber === task.taskNumber && props.employee.selectedTask.taskName === task.taskName}
                        />
                    ))}
                    <div className='mainContentRoot'>
                        {props.employee.isSelectedTaskCode && props.employee.taskSearchText && props.employee.selectedTask && !props.employee.allTaskList.some(task => task.taskNumber === props.employee.selectedTask.taskNumber && task.taskName === props.employee.selectedTask.taskName) &&
                            <Radio className="selectedRow w-100"
                                label={`${props.employee.selectedTask.taskNumber} - ${props.employee.selectedTask.taskName}`}
                                name='radioGroup'
                                value={props.employee.selectedTask}
                                checked
                            />
                        }


                        {props.employee.allTaskList && props.employee.allTaskList.filter(t => !props.employee.selectedTask || !(t.taskNumber === props.employee.selectedTask.taskNumber && t.taskName === props.employee.selectedTask.taskName)).map((task) => (
                            <Radio className="selectedRow w-100"
                                label={`${task.taskNumber} - ${task.taskName}`}
                                value={task}
                                onChange={() => { props.onTaskCodeSelect(task) }}
                                checked={props.employee.selectedTask && props.employee.selectedTask.taskNumber === task.taskNumber && props.employee.selectedTask.taskName === task.taskName}
                            />
                        ))}
                        {(props.employee.allTaskList.length === 0) &&
                            <NoResultFound displayMessage={Constants.NO_TASKS_FOUND} />
                        }
                        {props.employee.isShowLoader &&
                            <Loader />
                        }
                    </div>
                </Segment>
            }

            {props.employee.selectedTab === 'starttimeandtunchtime' &&
                <>
                    <Segment className="stickyHeader">
                        <Header as="h3" size='medium' textAlign='center'>Enter Punches</Header>
                    </Segment>
                    <Segment className="overflowScroll pb-5">
                        <div className="d-flex align-items-center justify-content-center pt-5">
                            <Header as='h4' size="medium">All Times are in 24 Hours Format</Header>
                        </div>
                        <Form unstackable className="pt-5 p-3 d-flex align-items justify-content-around w-75 margin-auto mt-5" autoComplete="off">
                            {groupTimeInput({
                                inputname: punches_text_keys[0],
                                hourValue: props.employee.startHour,
                                minuteValue: props.employee.startMinute,
                                checkBoxDisable: isHoursGreaterThanZero || isFourPointFiveHours,
                                inputDisable: isZeroHour,
                                checkBoxValue: isZeroHour,
                                hourRef: props.employee.startHourInputRef,
                                minuteRef: props.employee.startMinuteInputRef,
                            })}
                            {groupTimeInput({
                                inputname: punches_text_keys[1],
                                hourValue: props.employee.endHour,
                                minuteValue: props.employee.endMinute,
                                checkBoxDisable: isFourPointFiveHours || isHoursGreaterThanZero,
                                inputDisable: isZeroHour,
                                checkBoxValue: isZeroHour,
                                hourRef: props.employee.endHourInputRef,
                                minuteRef: props.employee.endMinuteInputRef,
                            })}
                        </Form>
                        <Form unstackable className="pt-5 p-3 d-flex align-items justify-content-around w-75 margin-auto" autoComplete="off">
                            {groupTimeInput({
                                inputname: punches_text_keys[2],
                                hourValue: props.employee.lunchStartHour,
                                minuteValue: props.employee.lunchStartMinute,
                                checkBoxDisable: isFourPointFiveHours,
                                inputDisable: lunchStartInputDisable,
                                checkBoxValue: lunchStartCheckBoxValue,
                                hourRef: props.employee.lunchStartHourInputRef,
                                minuteRef: props.employee.lunchStartMinuteInputRef,
                            })}
                            {groupTimeInput({
                                inputname: punches_text_keys[3],
                                hourValue: props.employee.lunchEndHour,
                                minuteValue: props.employee.lunchEndMinute,
                                checkBoxDisable: isFourPointFiveHours,
                                inputDisable: lunchEndInputDisable,
                                checkBoxValue: lunchEndCheckBoxValue,
                                hourRef: props.employee.lunchEndHourInputRef,
                                minuteRef: props.employee.lunchEndMinuteInputRef,
                            })}
                        </Form>
                    </Segment>
                    <Segment>
                        <div className='d-flex align-items justify-content-between btnFooter'>
                            <Button secondary onClick={() => props.onBackStartTimeLunchTime()} className="borderRadius w-10" size='small'>
                                Back</Button>
                            <Button secondary onClick={() => props.onSaveStartTimeLunchTime()} className="borderRadius w-10" size='small'>
                                Save</Button>
                        </div>
                    </Segment>
                </>
            }
            {/* Footer Button */}
            {props.employee.selectedTab !== 'starttimeandtunchtime' &&
                <Segment className="footerButtons">
                    <div className='d-flex align-items justify-content-between btnFooter'>
                        <Button onClick={() => props.onClickBack(props.employee.selectedTab)} secondary className="borderRadius w-10" size='small'>
                            Back  </Button>
                        {!props.employee.selectedTab &&
                            <Button onClick={props.onClickCreateTeam} secondary className="borderRadius w-20" size='small'>
                                {Constants.CREATE_FAVORITES} </Button>
                        }
                        {props.employee.selectedTab === "taskcodes" &&
                            <Button onClick={props.onClickCreateTaskCodeGroupTeam} secondary className="borderRadius w-20" size='small'>
                                {Constants.CREATE_FAVORITES}  </Button>
                        }
                        <Button onClick={() => props.onClickSave()} secondary className="borderRadius w-10" size='small' disabled={props.employee.disableSaveButton} >
                            Save  </Button>
                    </div>
                </Segment>
            }
            {/* Modal Section Start */}

            {/* Select Shift Modal */}
            <Modal
                open={props.employee.isSelectShiftModelVisible}
                size='tiny'
            >
                <Modal.Header className="text-center">Select Shift</Modal.Header>
                <Modal.Content className="text-center" scrolling style={{ minHeight: "auto" }}>
                    <Radio className="selectedRow textRight borderRadius w-100" label={Constants.DAY} name='radioGroup' value={Constants.DAY}
                        onChange={props.onShiftSelect}
                        checked={props.employee.onSelectedShift === Constants.DAY}
                    />
                    <Radio className="selectedRow textRight borderRadius w-100" label={Constants.EVENING} name='radioGroup' value={Constants.EVENING}
                        onChange={props.onShiftSelect}
                        checked={props.employee.onSelectedShift === Constants.EVENING}
                    />
                    <Radio className="selectedRow textRight borderRadius w-100" label={Constants.NIGHT} name='radioGroup' value={Constants.NIGHT}
                        onChange={props.onShiftSelect}
                        checked={props.employee.onSelectedShift === Constants.NIGHT}
                    />
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary active onClick={() => props.onCloseShiftModel()} className="borderRadius w-25" size='small' >
                        Back
                    </Button>
                    <Button secondary active onClick={() => props.onSaveShift()} className="borderRadius w-25" size='small' >
                        Save
                    </Button>
                </Modal.Actions>
                {props.employee.isShowLoader &&
                    <Loader />
                }
            </Modal>
            <Modal
                open={props.employee.isHoursTypeModelVisible}
                size='tiny'
            >
                <Modal.Header className="text-center">Select Pay Code</Modal.Header>
                <Modal.Content className="text-center" scrolling style={{ minHeight: "auto" }}>
                    <Radio className="selectedRow textRight borderRadius w-100" label={Constants.ST} name='radioGroup' value={Constants.ST}
                        onChange={props.onHoursTypeSelect}
                        checked={props.employee.onSelectedHoursType === Constants.ST}
                    />
                    <Radio className="selectedRow textRight borderRadius w-100" label={Constants.OT} name='radioGroup' value={Constants.OT}
                        onChange={props.onHoursTypeSelect}
                        checked={props.employee.onSelectedHoursType === Constants.OT}
                    />
                    <Radio className="selectedRow textRight borderRadius w-100" label={Constants.DT} name='radioGroup' value={Constants.DT}
                        onChange={props.onHoursTypeSelect}
                        checked={props.employee.onSelectedHoursType === Constants.DT}
                    />
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary active onClick={() => props.onCloseHoursTypeModel()} className="borderRadius w-25" size='small' >
                        Back
                    </Button>
                    <Button secondary active onClick={() => props.onSaveHoursType()} className="borderRadius w-25" size='small' >
                        Save
                    </Button>
                </Modal.Actions>
                {props.employee.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {/* Enter Hours Modal */}
            <Modal
                open={props.employee.isHoursModelVisible}
                size='tiny'
            >
                <Modal.Header className="text-center">Enter Hours</Modal.Header>
                <Modal.Content className="text-center" scrolling style={{ minHeight: "auto" }}>

                    <Form>
                        <Form.Input textAlign="center" style={{ border: 'none', borderBottom: '1px solid ghostwhite' }}
                            value={onSelectedHours}
                            maxLength={10}
                            onChange={props.onChangeHours} fluid />
                    </Form>
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary active onClick={() => props.onCloseHoursModel()} className="borderRadius w-25" size='small' >
                        Back
                    </Button>
                    <Button secondary active onClick={() => props.onSaveHours()} className="borderRadius w-25" size='small' >
                        Save
                    </Button>
                </Modal.Actions>
                {props.employee.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {props.employee.isShowAlreadyAttestedModal &&
                <ConfirmationPopup
                    isShowConfirmation={props.employee.isShowAlreadyAttestedModal}
                    confirmationMessage={Constants.ADD_UPDATE_TIMECARD_ALREADY_ATTESTED_MESSAGE}
                    confirmationHeader={Constants.WARNING_HEADER_MESSAGE}
                    isShowYes={false}
                    noText={Constants.BUTTON_BACK}
                    onClickCloseBtn={() => props.onCloseAlreadyAttestModal()}
                />
            }
            {props.employee.isShowLoader &&
                <Loader />
            }
        </Segment.Group>
    );
}

export default EmployeeComponent;

EmployeeComponent.displayName = "EmployeeComponent";